const requiredEnvVars = ['VITE_APP_NAME', 'VITE_API_BASE_URL', 'VITE_APP_ENV'] as const;

function getEnvVar(key: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

function validateEnv(): void {
  const missing = requiredEnvVars.filter((key) => !import.meta.env[key]);
  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
}

validateEnv();

export const env = {
  APP_NAME: getEnvVar('VITE_APP_NAME'),
  API_BASE_URL: getEnvVar('VITE_API_BASE_URL'),
  APP_ENV: getEnvVar('VITE_APP_ENV'),
  isDevelopment: getEnvVar('VITE_APP_ENV') === 'development',
  isProduction: getEnvVar('VITE_APP_ENV') === 'production',
} as const;
